import {
  useHasAccountFeatureFlagActive,
  useIsCurrentUserViewer,
} from 'utils/hooks/globalState';

export const useCanSelfUpgradeViewerLicense = () => {
  const isFeatureActive = useHasAccountFeatureFlagActive(
    'licenseManagementViewerSelfUpgrade'
  );
  const isViewer = useIsCurrentUserViewer();

  return isFeatureActive && isViewer;
};
